// import 'babel-polyfill';
import React, { Component } from 'react';
import './myutils';
import { Admin, Resource, resolveBrowserLocale } from 'react-admin';
import './App.css';
import { Login, Layout } from './layout';
import Menu from './layout/Menu';
import Dashboard from './dashboard/Dashboard';
import customRoutes from './routes';
import TemplateList,{ TemplateEdit, EntryEdit, EntryCreate } from './campaigns/templates';
import { CampaignList, CampaignEdit, CampaignShow } from './campaigns/ActiveCampaigns';
import ScheduledList from './campaigns/ScheduledCampaigns';
import Softphone from './Softphone/Softphone';
import restClient from './restClient';
import {i18nProvider} from './i18n';
import { ProfileEdit, ProfileList } from './profile';
import IVR from './IVR';
import Customers from './Customers';
import authProvider from './authProvider';
import { reducer as tree } from 'ra-tree-ui-materialui';
import ReactGA from 'react-ga';

class App extends Component {
    componentWillMount() {
        this.restoreFetch = restClient;

    }

    componentWillUnmount() {
        this.restClient();
    }


    componentDidMount() {
        //ReactGA.initialize('UA-155476865-1');
        //ReactGA.pageview(window.location.pathname + window.location.search);
    }
      
    render() {
        return (
            <Admin
                title=""
                dataProvider={restClient}
                customReducers={{ tree }}
                customRoutes={customRoutes}
                authProvider={authProvider}
                dashboard={Dashboard}
                loginPage={Login}
                appLayout={Layout}
                menu={Menu}
                locale={(sessionStorage.getItem("locale")!==null)?sessionStorage.locale:((resolveBrowserLocale()==='he')? ('he') : ('en'))}                     
                i18nProvider={i18nProvider}
            >
                <Resource name="Templates" list={TemplateList}
                 edit={TemplateEdit} 
                 />
                <Resource name="CreateTemplate"/>
                <Resource name="GetTemplateEntries" list={TemplateEdit} edit={EntryEdit} create={EntryCreate}/>
                <Resource name="Profile" 
                    list={ProfileList}
                    edit={ProfileEdit}
                 />
                <Resource name="ActiveCampaigns" list={CampaignList} edit={CampaignEdit} show={CampaignShow}/>
                <Resource name="ScheduledCampaigns" list={ScheduledList}  />
                <Resource name="Softphone" list={Softphone}/>
                <Resource name="IVR" {...IVR} />
                <Resource name="Customers" {...Customers} />
            </Admin>
        );
    }
}

export default App;
